module.exports = __webpack_public_path__ + "img/Perks-Gift-15.87c33f80.png";